module.exports = __webpack_public_path__ + "img/icon-dropdowneditor.0b48b377.svg";